import React from 'react';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserLock } from '@fortawesome/pro-light-svg-icons/faUserLock';
import { Formik, Form, Field } from 'formik';
import LinkButton from '../common/Buttons/LinkButton';
import Input from '../common/Formik/Input';

class EnterMfaCodeArea extends React.Component {
  validationSchema = () => {
    const { t } = this.props;
    return Yup.object().shape({
      mfaCode: Yup.string().required(t('validationRequired')),
    });
  };

  handleSubmit = (values) => {
    const { onSubmit } = this.props;
    onSubmit(values);
  };

  render() {
    const { passwordInfo, onConfirm, onCancel, t } = this.props;

    return (
      <Formik validationSchema={this.validationSchema()} initialValues={passwordInfo} onSubmit={this.handleSubmit}>
        {() => (
          <Form autoComplete="off">
            <div className="settings-list editing">
              <h1>
                <span>
                  <FontAwesomeIcon icon={faUserLock} />
                  &nbsp; {t('labelChangePassword')}
                </span>
                <LinkButton className="edit-button" onClick={onCancel}>
                  {t('labelGoBack')}
                </LinkButton>
              </h1>

              <div className="settings-list__item">
                <span className="label">MFA Code</span>
                <span className="input">
                  <Field name="mfaCode" type="text" autoComplete="off" component={Input} />
                </span>
              </div>
              <div className="text-right pt-2">
                <button type="submit" className="btn btn-secondary" onClick={onConfirm}>
                  {t('labelConfirm')}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default EnterMfaCodeArea;
